<img loading="lazy"[ngClass]="imageClass" [src]="src" [alt]="alt" [width]="width" [height]="height" />
